import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";

import "../../Styles/TenantCreateUsers.scss";
import Images from "../../Assets/Images";
import { connect } from "react-redux";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../Action/Tenant/TenantCreateUserForm";
import CircularProgress from "@material-ui/core/CircularProgress";
import { TreeView } from "@progress/kendo-react-treeview";
import OrganizationTreeList from "../Dashboard/OrganizationTreeList";
import WorkStreamWithRoles from "../Dashboard/WorkStreamWithRoles";
import { toastr } from "react-redux-toastr";
// import { MaxDivHeightScaler } from "ag-grid-community/dist/lib/rendering/maxDivHeightScaler";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

class TenantAddUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      updateFlag: false,
      readOnly: false,      
      orgunitIds: [],
      PasswordVisibility:false,
      roleArrayRisk:[],
      roleArrayTask:[]
       };
      this.populateUserDate(this.props.location.editUserData);    
  }

  componentDidMount() {
    this.getOrganizationsUnits();
  }

  getOrganizationsUnits = async () => {
    var loggedClient = secureLocalStorage.getItem("loggedClient");
    var createdby =
      loggedClient == "user"
        ? secureLocalStorage.getItem("userId")
        : secureLocalStorage.getItem("tenantId");
    var params = {
      CreatedBy: parseInt(createdby),
    };
    const { actions } = this.props;
    await actions.getOrganizationsUnits(params);
    this.setState({
      workstreamData: this.props.workstreamData,
    });
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.dataCreationFailure != null) {
      const token =
        secureLocalStorage.getItem("loggedClient") == "user"
          ? secureLocalStorage.getItem("userKey")
          : secureLocalStorage.getItem("tenantKey");
      const loggedClient = secureLocalStorage.getItem("loggedClient");
      nextProps.history.push(`/${loggedClient}/${token}`);
      // secureLocalStorage.clear();
      return { null: nextProps.actions.UserCreationFailure(null) };
    }
    return null;
  }

  TenantName = (e) => {
    const { actions } = this.props;
    actions.tenantName(e.target.value);
  };
  TenanatJobTitle = (e) => {
    const { actions } = this.props;
    actions.tenantJobTitle(e.target.value);
  };

  tenantEmail = (e) => {
    const { actions } = this.props;
    actions.tenantEmail(e.target.value);
  };

  tenantTelephone = (e) => {
    const { actions } = this.props;
    actions.tenantPhone(e.target.value);
  };

  tenantPassword = (e) => {
    const { actions } = this.props;
    actions.tenantPassword(e.target.value);
   
  };

  isTenantAdmin = (e) => {
    const { actions } = this.props;
    actions.isTenantAdmin(e);
  };

  workStreamIds = (ids) => {
    const { actions } = this.props;
    actions.workStreamIds(ids);
  };

  setEmptyWorkStream = () => {
    const { actions } = this.props;
    actions.workStreamIds([]);
  };

  validateForm() {
    const {
      tenantname,
      tenantRole,
      tenantjobTitle,
      tenantEmail,
      tenantPhoneNumber,
      tenantPassword,
      isTenantAdmin,
      workStreamIds,
    } = this.props;
    let errors = {};
    let formIsValid = true;
    if (!tenantname) {
      formIsValid = false;
      errors["tenantname"] = "*Please enter your username";
    }
    // if (tenantname !== "" && !tenantname.match(/^[a-zA-Z ]*$/)) {
    //   formIsValid = false;
    //   errors["tenantname"] = "*Please enter alphabet characters only";
    // }
    if (!tenantEmail) {
      formIsValid = false;
      errors["tenantEmail"] = "*Please enter a valid email address";
    }

    // if (!tenantPhoneNumber) {
    //   formIsValid = false;
    //   errors["tenantPhoneNumber"] = "*Please enter valid telephone.";
    // }
   

    if (!tenantPassword) {
      formIsValid = false;
      errors["tenantPassword"] = "*Please enter valid password.";
    }
    if (!isTenantAdmin) {
      formIsValid = false;
      errors["tenantRole"] = "*Please enter valid User Type.";
    }

    // if (!tenantjobTitle) {
    //   formIsValid = false;
    //   errors["tenantjobTitle"] = "*Please enter valid Job.";
    // }
    if (tenantPassword && !this.state.updateFlag) {
      var paswd =
        /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{7,15}$/;
      if (tenantPassword.match(paswd)) {
        //  formIsValid = true;
      } else {
        formIsValid = false;
        errors["tenantPassword"] =
          "*A password between 8 to 15 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character";
      }
    }
    this.setState({
      errors: errors,
    });

    return formIsValid;
  }

  validateFormForUpdate() {
    const {
      tenantname,
      tenantRole,
      tenantjobTitle,
      tenantEmail,
      tenantPhoneNumber,
      tenantPassword,
      isTenantAdmin,
      workStreamIds,
    } = this.props;
    let errors = {};
    let formIsValid = true;
    if (!tenantname) {
      formIsValid = false;
      errors["tenantname"] = "*Please enter your username";
    }
    // if (tenantname !== "" && !tenantname.match(/^[a-zA-Z ]*$/)) {
    //   formIsValid = false;
    //   errors["tenantname"] = "*Please enter alphabet characters only";
    // }
    if (!tenantEmail) {
      formIsValid = false;
      errors["tenantEmail"] = "*Please enter valid email address";
    }

    // if (!tenantPhoneNumber) {
    //   formIsValid = false;
    //   errors["tenantPhoneNumber"] = "*Please enter valid telephone.";
    // }
   

    if (!isTenantAdmin) {
      formIsValid = false;
      errors["tenantRole"] = "*Please enter valid User Type.";
    }

    // if (!tenantjobTitle) {
    //   formIsValid = false;
    //   errors["tenantjobTitle"] = "*Please enter valid Job.";
    // }

    this.setState({
      errors: errors,
    });

    return formIsValid;
  }
  submitUserData = async (event) => {
    console.log("asaasa")
    event.preventDefault();
    if (this.validateForm()) {
      const {
        actions,
        tenantname,
        tenantRole,
        tenantjobTitle,
        tenantEmail,
        tenantPhoneNumber,
        tenantPassword,
        isTenantAdmin,
        workStreamIds,
      } = this.props;

      let orgunitIds=this.constructWorkstreamRoleJson(this.state.roleArrayRisk,this.state.roleArrayTask);
      // let roleFlag=this.areAllKeysFilled(orgunitIds);
      // if ( !roleFlag) {
      //   toastr.error("Please select role for all the workstreams");
      //   return;
      // }
      let wsIds=workStreamIds?workStreamIds:orgunitIds.map(item => item.id)

      let params = {
        Name: tenantname,
        Role: "-", //tenantRole.value,
        Telephone: tenantPhoneNumber,
        EmailAddress: tenantEmail,
        Password: tenantPassword,
        isTenantAdmin:isTenantAdmin? isTenantAdmin.value=="false"?false:true:isTenantAdmin,
        JobTitle: tenantjobTitle,
        workStreamIds: wsIds,
        orgunitIds: this.props.isTenantAdmin.value=="true"?[]:orgunitIds.filter(org => wsIds?.includes(org.id)),
      };
      
      await actions.userAddingByAdmin(params);
      this.cancelUserData();
    }
  };
   areAllKeysFilled = (array) => {
    const requiredKeys = ['id', 'taskRole', 'role'];
    return array.every(obj =>
      requiredKeys.every(key => obj.hasOwnProperty(key) && obj[key] !== undefined && obj[key] !== null && obj[key] !== '')
    );
  };
  populateUserDate(data) {
    const { actions } = this.props;
    if(data!=null){
    actions.tenantName(data.name);
    actions.tenantJobTitle(data.jobTitle);
    actions.tenantEmail(data.emailAddress);
    actions.tenantPhone(data.telephone);
    actions.tenantPassword(data.password);    
    var userTypelabel = (!data.isTenantAdmin?"User":"Tenant Admin");
    var userType = { value: data.isTenantAdmin.toString(), label: userTypelabel };
    actions.isTenantAdmin(userType);
    actions.workStreamIds(data.workStreamIds);    
    var role = { value: data.role, label: data.role };
    actions.tenantRole(role);
    let ids = [];
    for (var i = 0; i < data.workstreamRoles.length; i++) {
      ids.push(data.workstreamRoles[i].workstreamId);
    }
    this.state = {
      ...this.state,
      updateFlag: true,
      readOnly: true,
      selectedOrgUnit: ids,
      workstreamRoles: data.workstreamRoles,
      userId:data.userId
    };
  }
  else
  {
    actions.tenantName("");
    actions.tenantJobTitle("");
    actions.tenantEmail("");
    actions.tenantPhone("");
    actions.tenantPassword("");
    // Set default user type to "User"
    const defaultUserType = { value: "false", label: "User" };
    actions.isTenantAdmin(defaultUserType);
  }
  }

  updateUserData = async (event) => {
    console.log("update")
    event.preventDefault();
    if (this.validateFormForUpdate()) {
      const {
        actions,
        tenantname,
        tenantRole,
        tenantjobTitle,
        tenantEmail,
        tenantPhoneNumber,
        tenantPassword,
        isTenantAdmin,
        workStreamIds,
      } = this.props;
      var isTenantAdminval = this.props.isTenantAdmin.value=="true"?true:false;   
      var role= this.props.isTenantAdmin.value=="true"?"-":"Tenant";  

      let orgunitIds=this.constructWorkstreamRoleJson(this.state.roleArrayRisk,this.state.roleArrayTask);
      // let roleFlag=this.areAllKeysFilled(orgunitIds);
      // if (!roleFlag) {
      //   toastr.error("Please select role for all the workstreams");
      //   return;
      // }
let wsIds=workStreamIds?workStreamIds:orgunitIds.map(item => item.id)
      let params = {
        Name: tenantname,
        Role: role,
        Telephone: tenantPhoneNumber,
        EmailAddress: tenantEmail,
        Password: tenantPassword,
        isTenantAdmin: isTenantAdminval,
        JobTitle: tenantjobTitle,
        workStreamIds: wsIds,
        userId:this.state.userId,
        orgunitIds: this.props.isTenantAdmin.value=="true"?[]:orgunitIds.filter(org => wsIds.includes(org.id)),
      };
    
      await actions.updateUserAddingByAdmin(params);
      this.cancelUserData();
    }
  };

  cancelUserData = (event) => {
    const token =
      secureLocalStorage.getItem("loggedClient") == "user"
        ? secureLocalStorage.getItem("userKey")
        : secureLocalStorage.getItem("tenantKey");
    const loggedClient = secureLocalStorage.getItem("loggedClient");
    this.props.history.push({
      pathname: `/${loggedClient}/${token}/home/admin`,
      adminActiveMenu: "user",
    });
  };
  onItemClick = (event) => {
    event.item.selected = !event.item.selected;
    this.forceUpdate();
  };
  onExpandChange = (event) => {
    event.item.expanded = !event.item.expanded;
    this.forceUpdate();
  };

   constructWorkstreamRoleJson = (arr1, arr2) => {
    const merged = arr1.map(item1 => {
        const match = arr2.find(item2 => item2.id === item1.id);
        return match ? { id: item1.id, role: item1.role, taskRole: match.taskRole } : item1;
    });

    // Add items from arr2 that are not in arr1
    const unmatched = arr2
        .filter(item2 => !arr1.some(item1 => item1.id === item2.id))
        .map(item2 => ({ id: item2.id, taskRole: item2.taskRole })); // Ensuring format consistency

    return [...merged, ...unmatched];
};
  saveRoleWithOrgIdForRisk = (data) => {
    this.setState({ ...this.state, roleArrayRisk: data }, () => {
      //callback
      console.log("roleArrayRisk", this.state.roleArrayRisk); 
    });
  };
 
  saveRoleWithOrgIdForTask = (data) => {
    this.setState({ ...this.state, roleArrayTask: data }, () => {
      //callback
      console.log("roleArrayTask", this.state.roleArrayTask); 
    });
  };

  render() {       
    

    const usertypeoptions = [
      { value: "true", label: "Tenant Admin" },
      { value: "false", label: "User" },
    ];

    const {
      tenantname,
      tenantRole,
      tenantjobTitle,
      tenantEmail,
      tenantPhoneNumber,
      tenantPassword,
      isTenantAdmin,
      workStreamIds,
      loader,
    } = this.props;
    return (
      <div className="appCont">
        <div className="mainWrapper">
          <div className="rm-tanent-cont">
            <div className="rm-form-cont relPosition">
              <h6>{this.state.updateFlag ? "Edit User" : "Add User"}</h6>

              {/* Spinner */}
              {loader ? (
                <span className="MatTableSpinner">
                  <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
                </span>
              ) : null}

              {/* <form name="form"> */}
              <div className="rm-form" id="tenant-user-form" autoComplete="off">
                <div className="rm-field-container">
                  <label>Name</label>
                  <input
                    value={tenantname || ""}
                    type="text"
                    name="name"
                    onChange={(e) => this.TenantName(e)}
                    className="form-control"
                    placeholder="Enter User Name"
                    autoComplete="off"
                  />
                  <div className="errorMsg">{this.state.errors.tenantname}</div>
                </div>

                <div className="rm-field-container rm-service-plan">
                  <label>Job Title</label>
                  <input
                    value={tenantjobTitle || ""}
                    onChange={(e) => this.TenanatJobTitle(e)}
                    type="text"
                    name="jobTitle"
                    className="form-control"
                    placeholder=""
                    autoComplete="off"
                  />
                  <div className="errorMsg">
                    {this.state.errors.tenantjobTitle}
                  </div>
                </div>
                <div className="rm-field-container rm-service-plan">
                  <label>Email</label>
                  <input
                    value={tenantEmail || ""}
                    onChange={(e) => this.tenantEmail(e)}
                    type="email"
                    name="email"
                    autoComplete="new-email"
                    className="form-control"
                    placeholder=""
                    // readOnly={this.state.readOnly}
                  />
                  <div className="errorMsg">
                    {this.state.errors.tenantEmail}
                  </div>
                </div>
                <div className="rm-field-container rm-service-plan">
                  <label>Telephone</label>
                  <input
                    value={tenantPhoneNumber || ""}
                    onChange={(e) => this.tenantTelephone(e)}
                    type="text"
                    name="telephone"
                    className="form-control"
                    placeholder=""
                    autoComplete="new-telephone"
                  />
                  <div className="errorMsg">
                    {this.state.errors.tenantPhoneNumber}
                  </div>
                </div>
                {!this.state.readOnly && (
                  <div className="rm-field-container rm-service-plan">
                    <label>Password</label>
                    <div className="ip-field">
                      <input
                        value={tenantPassword || ""}
                        onChange={(e) => this.tenantPassword(e)}
                        type={
                          this.state.PasswordVisibility === false
                            ? "password"
                            : "text"
                        }
                        name="password"
                        className="form-control"
                        placeholder=""
                        //readOnly={this.state.readOnly}
                        autoComplete="new-password"
                      />
                      {/* <span 
                    onClick={()=>this.setState({PasswordVisibility:!this.state.PasswordVisibility})}
                    > 
                      
                     { this.state.PasswordVisibility?<VisibilityOutlinedIcon htmlColor="#009660"/>:<VisibilityOffOutlinedIcon htmlColor="#009660"/>}
                     </span> */}
                      <div className="errorMsg">
                        {this.state.errors.tenantPassword}
                      </div>
                    </div>
                  </div>
                )}

                <div className="user-type-dropdown">
                  <label>User Type</label>
                  <DropDownList
                    data={usertypeoptions}
                    textField="label"
                    dataItemKey="value"
                    value={isTenantAdmin}
                    onChange={(e) => {
                      this.isTenantAdmin(e.target.value);
                    }}
                    //className="user-type-dropdown"
                  />
                  <div className="errorMsg">
                    {this.state.errors.isTenantAdmin}
                  </div>
                </div>
                {isTenantAdmin.value == "false" ? (
                  <div className="rm-field-container-50 rm-service-plan">
                    <label>Assigned Workstreams</label>
                    <div className="selectWorkStream">
                      <WorkStreamWithRoles
                        selectedOrgUnit={this.state.selectedOrgUnit}
                        orgUnitData={this.state.workstreamData}
                        getRiskList={this.workStreamIds}
                        getEmptyRiskList={this.setEmptyWorkStream}
                        saveRoleWithOrgIdForRisk={this.saveRoleWithOrgIdForRisk}
                        saveRoleWithOrgIdForTask={this.saveRoleWithOrgIdForTask}
                        editModeWorkstreamRoles={this.state.workstreamRoles}
                        isTenent={true}
                      />
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="btn-group">
                {this.state.updateFlag ? (
                  <button
                    onClick={(e) => {
                      this.updateUserData(e);
                    }}
                    className="rm-btn-primary"
                  >
                    Update
                  </button>
                ) : (
                  <button
                    onClick={(e) => {
                      this.submitUserData(e);
                    }}
                    className="rm-btn-primary"
                  >
                    Submit
                  </button>
                )}
                &nbsp;&nbsp;
                <button
                  onClick={(e) => {
                    this.cancelUserData(e);
                  }}
                  className="rm-btn-primary"
                >
                  Cancel
                </button>
              </div>
              {/* </form> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => {
  return {
    tenantname: state.TenantCreateUserForm.name,
    tenantRole: state.TenantCreateUserForm.role,
    tenantjobTitle: state.TenantCreateUserForm.jobTitle,
    tenantEmail: state.TenantCreateUserForm.email,
    tenantPhoneNumber: state.TenantCreateUserForm.phone,
    tenantPassword: state.TenantCreateUserForm.password,
    isTenantAdmin: state.TenantCreateUserForm.isTenantAdmin,
    loader: state.TenantCreateUserForm.loaderStatus,
    dataCreationFailure: state.TenantCreateUserForm.userCreationFailure,
    workstreamData: state.TenantCreateUserForm.workstreamData,
    workStreamIds: state.TenantCreateUserForm.workStreamIds,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TenantAddUsers);
